import Image from "next/image";
import { forwardRef, createElement } from "react";
import { imageConfigDefault } from "next/dist/shared/lib/image-config";
function createImageSrcset({ src, width }) {
  if (src.toString().endsWith(".svg")) {
    return { src };
  }
  const sizes = imageConfigDefault.imageSizes.concat(imageConfigDefault.deviceSizes);
  const halfIndex = Math.floor(sizes.length / 2);
  const size1x = sizes.find((size) => size > parseInt(String(width))) ?? sizes[halfIndex - 1];
  const size2x = sizes.find((size) => size >= size1x * 2) ?? sizes[halfIndex + 2];
  const m = src.toString().match(/^(.+)\/(.+)\.\w+$/);
  if (!m) {
    throw new Error(`Could not match path, filename and extension of src='${src}'`);
  }
  const [_, path, name] = m;
  const srcset = [
    `${path}/${name}-${size1x}.webp`,
    `${path}/${name}-${size2x}.webp`
  ];
  return {
    src: srcset[1],
    srcSet: srcset.map((p, i) => `${p} ${i + 1}x`).join(",")
  };
}
const NextImageStub = forwardRef(({ priority, ...props }, ref) => createElement("img", {
  loading: priority ? null : "lazy",
  fetchpriority: priority ? "high" : undefined,
  decoding: "async",
  "data-nimg": "1",
  style: { color: "transparent" },
  ...props,
  ref,
  ...createImageSrcset(props)
}));
export default NextImageStub;
